import type { ChapterItem } from '@app/_proto/Protos/chapters';
import useChapterStatus from '@app/domains/common/hooks/useChapterStatus';

type UseChapterNavigationStatusParam = {
    chapter: ChapterItem | undefined;
};

type UseChapterNavigationStatusReturn = {
    prevDisabled: boolean;
    nextDisabled: boolean;
};

export default function useChapterNavigationStatus({
    chapter,
}: UseChapterNavigationStatusParam): UseChapterNavigationStatusReturn {
    const { prevChapterSlug, nextChapterSlug, isAdvancedChapter, isUnlockedChapter } = useChapterStatus({
        chapter,
    });
    const isLockedAdvancedChapter = !!isAdvancedChapter && !isUnlockedChapter;
    const prevDisabled = !prevChapterSlug;
    const nextDisabled = !nextChapterSlug || isLockedAdvancedChapter;
    return { prevDisabled, nextDisabled };
}
